import { createSelector } from "@reduxjs/toolkit";

export const selectGeoplaces = (state) => state.entities.geoplaces.entity.data;
export const selectGeoplacesAsArray = createSelector(
  [selectGeoplaces],
  (geoplaces) => (geoplaces ? Object.values(geoplaces) : [])
);
export const selectIsLoadingGeoplaces = (state) =>
  state.entities.geoplaces.entity.isLoading;
